

// import React, { useEffect, useState, useMemo } from 'react';
// import dayjs from 'dayjs';
// import relativeTime from 'dayjs/plugin/relativeTime';
// import './collectdata.css';

// dayjs.extend(relativeTime);

// const formatTime = (timeStr) => {
//   if (!timeStr) return '';
//   const [h, m] = timeStr.split(':');
//   const hour = parseInt(h);
//   const minute = parseInt(m);
//   const ampm = hour >= 12 ? 'PM' : 'AM';
//   const hr = hour % 12 || 12;
//   return `${hr}.${minute.toString().padStart(2, '0')} ${ampm}`;
// };

// const getGroupLabel = (dateStr) => {
//   const today = dayjs();
//   const entry = dayjs(dateStr);
//   if (entry.isSame(today, 'day')) return 'Today';
//   if (entry.isSame(today.subtract(1, 'day'), 'day')) return 'Yesterday';
//   return entry.format('DD-MM-YYYY');
// };

// const Collecttea = () => {
//   const [rawData, setRawData] = useState([]);
//   const [searchText, setSearchText] = useState('');
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [page, setPage] = useState(0);
//   const pageSize = 25;

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const res = await fetch('https://kmtea.onrender.com/collecttea');
//         if (!res.ok) throw new Error('Failed to fetch');
//         const result = await res.json();
//         const sorted = result.sort((a, b) => {
//           const dateCompare = new Date(b.date) - new Date(a.date);
//           if (dateCompare === 0) {
//             return (b.time || '').localeCompare(a.time || '');
//           }
//           return dateCompare;
//         });
//         setRawData(sorted);
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//     const interval = setInterval(fetchData, 10000);
//     return () => clearInterval(interval);
//   }, []);

//   const filteredData = useMemo(() => {
//     return rawData.filter(item =>
//       item.name?.toLowerCase().includes(searchText.toLowerCase()) ||
//       item.date?.includes(searchText) ||
//       item.farmid?.toLowerCase().includes(searchText.toLowerCase())
//     );
//   }, [searchText, rawData]);

//   const paginatedData = useMemo(() => {
//     const start = page * pageSize;
//     const end = start + pageSize;
//     return filteredData.slice(start, end);
//   }, [filteredData, page]);

//   const grouped = useMemo(() => {
//     const groups = {};
//     paginatedData.forEach(item => {
//       const label = getGroupLabel(item.date);
//       if (!groups[label]) groups[label] = [];
//       groups[label].push(item);
//     });

//     const order = ['Today', 'Yesterday'];
//     const sorted = Object.entries(groups).sort(([a], [b]) => {
//       if (order.includes(a) && order.includes(b)) {
//         return order.indexOf(a) - order.indexOf(b);
//       } else if (order.includes(a)) return -1;
//       else if (order.includes(b)) return 1;
//       return dayjs(b, 'DD-MM-YYYY').toDate() - dayjs(a, 'DD-MM-YYYY').toDate();
//     });

//     return sorted;
//   }, [paginatedData]);

//   const totalPages = Math.ceil(filteredData.length / pageSize);

//   if (loading) return <div className="tea-info-message">Loading...</div>;
//   if (error) return <div className="tea-error-message">Error: {error}</div>;

//   return (
//     <div className="tea-collection-wrapper">
//       <h2 className="tea-heading">Tea Collection Details</h2>
//       <input
//         type="text"
//         className="tea-search-input"
//         placeholder="Search by name, farm ID, or date"
//         value={searchText}
//         onChange={(e) => setSearchText(e.target.value)}
//       />
//       {grouped.map(([label, rows]) => (
//         <div className="tea-group-box" key={label}>
//           <h3 className="tea-group-title">{label}</h3>
//           <table className="tea-table">
//             <thead>
//               <tr>
//                 <th>Date</th>
//                 <th>Time</th>
//                 <th>Farm ID</th>
//                 <th>Name</th>
//                 <th>Area</th>
//                 <th>Qty List</th>
//                 <th>Qty Total</th>
//                 <th>Tare</th>
//                 <th>Water</th>
//                 <th>Stick</th>
//                 <th>Net Weight</th>
//                 <th>Emp ID</th>
//               </tr>
//             </thead>
//             <tbody>
//               {rows.map((row, idx) => (
//                 <tr key={idx} className={label === 'Today' ? 'highlight-today-row' : ''}>
//                   <td>{dayjs(row.date).format('DD-MM-YYYY')}</td>
//                   <td>{formatTime(row.time)}</td>
//                   <td>{row.farmid}</td>
//                   <td>{row.name}</td>
//                   <td>{row.area}</td>
//                   <td>
//                     {(() => {
//                       try {
//                         const parsed = typeof row.qtyList === 'string' ? JSON.parse(row.qtyList) : row.qtyList;
//                         return Array.isArray(parsed) ? parsed.join(', ') : row.qtyList;
//                       } catch {
//                         return row.qtyList;
//                       }
//                     })()}
//                   </td>
//                   <td>{row.qty}</td>
//                   <td>{row.tare}</td>
//                   <td>{row.water}</td>
//                   <td>{row.stick}</td>
//                   <td>{row.netweight}</td>
//                   <td>{row.empid}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       ))}
//       <div className="tea-pagination">
//         <button onClick={() => setPage(p => Math.max(p - 1, 0))} disabled={page === 0}>
//           Prev
//         </button>
//         <span>Page {page + 1} of {totalPages}</span>
//         <button onClick={() => setPage(p => Math.min(p + 1, totalPages - 1))} disabled={page >= totalPages - 1}>
//           Next
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Collecttea;


import React, { useEffect, useState, useMemo } from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { FaSms, FaWhatsapp,FaPaperPlane } from 'react-icons/fa';
import { FaTrash } from 'react-icons/fa';

import './collectdata.css';

dayjs.extend(relativeTime);

// === Helper Functions ===
function formatDate(inputDate) {
  const [year, month, day] = inputDate.split('-');
  return `${day}-${month}-${year}`;
}

function getMonthName(dateStr) {
  const dateObj = new Date(dateStr);
  return dateObj.toLocaleString('default', { month: 'long' });
}

function getBillValue(billTare, water, stick) {
  let billValue = String(billTare);
  if (water > 0 && stick === 0) {
    billValue = `${billTare} Kg , water:${water}`;
  } else if (water === 0 && stick > 0) {
    billValue = `${billTare} Kg , stick:${stick}`;
  } else if (water > 0 && stick > 0) {
    billValue = `${billTare} Kg , water:${water}kg , stick:${stick}`;
  }
  return billValue;
}

const formatTime = (timeStr) => {
  if (!timeStr) return '';
  const [h, m] = timeStr.split(':');
  const hour = parseInt(h);
  const minute = parseInt(m);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const hr = hour % 12 || 12;
  return `${hr}.${minute.toString().padStart(2, '0')} ${ampm}`;
};

const getGroupLabel = (dateStr) => {
  const today = dayjs();
  const entry = dayjs(dateStr);
  if (entry.isSame(today, 'day')) return 'Today';
  if (entry.isSame(today.subtract(1, 'day'), 'day')) return 'Yesterday';
  return entry.format('DD-MM-YYYY');
};

const Collecttea = () => {
  const [rawData, setRawData] = useState([]);
  const [farmers, setFarmers] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [previewSMS, setPreviewSMS] = useState(null);
  const [showSMSPreview, setShowSMSPreview] = useState(false);
  const pageSize = 25;
const [deleteBillNo, setDeleteBillNo] = useState(null);
const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [teaRes, farmerRes] = await Promise.all([
          fetch('https://kmtea.onrender.com/collecttea'),
          fetch('https://kmtea.onrender.com/farmers')
        ]);
        if (!teaRes.ok || !farmerRes.ok) throw new Error('Failed to fetch data');
        const teaData = await teaRes.json();
        const farmerData = await farmerRes.json();

        const sortedTea = teaData.sort((a, b) => {
          const dateCompare = new Date(b.date) - new Date(a.date);
          if (dateCompare === 0) {
            return (b.time || '').localeCompare(a.time || '');
          }
          return dateCompare;
        });

        setRawData(sortedTea);
        setFarmers(farmerData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    const interval = setInterval(fetchData, 10000);
    return () => clearInterval(interval);
  }, []);

  const mergedData = useMemo(() => {
    return rawData.map(row => {
      const farmerMatch = farmers.find(f => f.farmid === row.farmid);
      return { ...row, ph: farmerMatch?.ph || '' };
    });
  }, [rawData, farmers]);

  const filteredData = useMemo(() => {
    return mergedData.filter(item =>
      item.name?.toLowerCase().includes(searchText.toLowerCase()) ||
      item.date?.includes(searchText) ||
      item.farmid?.toLowerCase().includes(searchText.toLowerCase())
    );
  }, [searchText, mergedData]);

  const paginatedData = useMemo(() => {
    const start = page * pageSize;
    const end = start + pageSize;
    return filteredData.slice(start, end);
  }, [filteredData, page]);

  const grouped = useMemo(() => {
    const groups = {};
    paginatedData.forEach(item => {
      const label = getGroupLabel(item.date);
      if (!groups[label]) groups[label] = [];
      groups[label].push(item);
    });

    const order = ['Today', 'Yesterday'];
    return Object.entries(groups).sort(([a], [b]) => {
      if (order.includes(a) && order.includes(b)) {
        return order.indexOf(a) - order.indexOf(b);
      } else if (order.includes(a)) return -1;
      else if (order.includes(b)) return 1;
      return dayjs(b, 'DD-MM-YYYY').toDate() - dayjs(a, 'DD-MM-YYYY').toDate();
    });
  }, [paginatedData]);

  const handleSMSPreview = async (row) => {
    if (!row.farmid || !row.date) return;

    const cleanFarmId = String(row.farmid).trim().replace(/^"|"$/g, '');
    const selectedMonth = row.date.slice(0, 7);

    try {
      const res = await fetch('https://kmtea.onrender.com/collecttea');
      const data = await res.json();

      const monthlyData = data.filter(item =>
        item.farmid === cleanFarmId && item.date.slice(0, 7) === selectedMonth
      );

      const monthlyTotalQty = monthlyData.reduce((sum, item) => sum + item.netweight, 0);

      const billEntry = monthlyData.find(item => item.billno === row.billno);
      const billTare = billEntry?.tare || 0;
      const billWater = billEntry?.water || 0;
      const billStick = billEntry?.stick || 0;

      const qtyList = typeof row.qtyList === 'string'
        ? JSON.parse(row.qtyList)
        : row.qtyList || [];

      const totalQty = qtyList.reduce((sum, qty) => sum + qty, 0);
      const billValue = getBillValue(billTare, billWater, billStick);

      const message = [
        "கம்மந்து ஸ்ரீ கன்னி மாரி அம்மன்",
        `தேதி : ${formatDate(row.date)}`,
        `பெயர் : ${row.name}`,
        `மொத்த பைகள் : ${qtyList.length} - ${qtyList.join(', ')}`,
        `மொத்த எடை : ${totalQty}kg | டேர் : ${billValue}kg | நிகர எடை : ${row.netweight}kg`,
        `மாத மொத்த நிகர எடை (${getMonthName(row.date)}-${new Date(row.date).getFullYear().toString().slice(-2)}) : ${monthlyTotalQty}kg`
      ].join('\n');

      setPreviewSMS({
        ph: row.ph,
        message,
        billTare,
        billWater,
        billStick,
        date: row.date,
        name: row.name,
        qtyList,
        totalQty,
        netweight: row.netweight,
        monthlyTotalQty
      });
      setShowSMSPreview(true);
    } catch (err) {
      console.error('Error preparing SMS preview:', err);
    }
  };

  const sendToWhatsApp = () => {
    const phone = String(previewSMS.ph).replace('+91', '').trim();
    window.open(`https://wa.me/91${phone}?text=${encodeURIComponent(previewSMS.message)}`, '_blank');
  };

  const sendSMSNow = async () => {
    const { ph, date, name, qtyList, totalQty, billTare, billWater, billStick, netweight, monthlyTotalQty } = previewSMS;
    const billValue = getBillValue(billTare, billWater, billStick);
    const formattedNumber = String(ph).startsWith('+') ? ph : `+91${ph}`;
    let variables_values = '';
    let template_id = '';

    if (qtyList.length <= 5) {
      variables_values = [
        formatDate(date), name, qtyList.length, qtyList.join(', '),
        totalQty, billValue, netweight,
        getMonthName(date), new Date(date).getFullYear().toString().slice(-2),
        monthlyTotalQty
      ].join('|');
      template_id = '194483';
    } else {
      const splitIntoThreeParts = (arr) => {
        const partSize = Math.floor(arr.length / 3);
        const remainder = arr.length % 3;
        let firstEnd = partSize, secondEnd = partSize * 2;
        if (remainder === 1) firstEnd += 1;
        else if (remainder === 2) { firstEnd += 1; secondEnd += 1; }
        return {
          firstbags: arr.slice(0, firstEnd).join(', '),
          secondbags: arr.slice(firstEnd, secondEnd).join(', '),
          thirdbags: arr.slice(secondEnd).join(', ')
        };
      };
      const { firstbags, secondbags, thirdbags } = splitIntoThreeParts(qtyList);
      variables_values = [
        formatDate(date), name, qtyList.length,
        firstbags, secondbags, thirdbags,
        totalQty, billValue, netweight,
        getMonthName(date), new Date(date).getFullYear().toString().slice(-2),
        monthlyTotalQty
      ].join('|');
      template_id = '194742';
    }

    try {
      const res = await fetch('https://kmtea.onrender.com/send-sms', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ to: formattedNumber, variables_values, template_id }),
      });
      const data = await res.json();
      alert(data.success ? 'SMS sent successfully!' : 'SMS failed: ' + JSON.stringify(data));
    } catch (err) {
      alert('Error sending SMS: ' + err.message);
    }
    setShowSMSPreview(false);
  };

  const totalPages = Math.ceil(filteredData.length / pageSize);

  if (loading) return <div className="tea-info-message">Loading...</div>;
  if (error) return <div className="tea-error-message">Error: {error}</div>;
const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};
const handleDelete = async (billno) => {
  try {
    const res = await fetch(`https://kmtea.onrender.com/collecttea/${billno}`, {
      method: 'DELETE'
    });
    const data = await res.json();
    if (data.success) {
      // fetchData(); 
      alert('Record deleted successfully!');
    } else {
      alert('Delete failed: ' + data.message);
    }
  } catch (error) {
    alert('Error deleting record: ' + error.message);
  }
  setShowDeleteDialog(false);
};

  return (
    <div className="tea-collection-wrapper">
      <h2 className="tea-heading">Tea Collection Details</h2>
      <input
        type="text"
        className="tea-search-input"
        placeholder="Search by name, farm ID, or date"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />
      {grouped.map(([label, rows]) => (
        <div className="tea-group-box" key={label}>
          <h3 className="tea-group-title">{label}</h3>
          <table className="tea-table">
            <thead>
              <tr>
                <th>Billno</th>
                <th>Date</th>
                <th>Time</th>
                <th>Farm ID</th>
                <th>Name</th>
                <th>Area</th>
                <th>Qty List</th>
                <th>Qty Total</th>
                <th>Tare</th>
                <th>Water</th>
                {rows.some(r => r.stick && r.stick !== 0) && <th>Stick</th>}
                <th>Net Weight</th>
                <th>Emp ID</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, idx) => (
                <tr key={idx} className={label === 'Today' ? 'highlight-today-row' : ''}>
                 <td>{row.billno}</td>
                  <td>{dayjs(row.date).format('DD-MM-YYYY')}</td>
                  <td>{formatTime(row.time)}</td>
                  <td>{row.farmid}</td>
                  <td>{row.name}</td>
                  <td>{row.area}</td>
                  <td>
                    {(() => {
                      try {
                        const parsed = typeof row.qtyList === 'string' ? JSON.parse(row.qtyList) : row.qtyList;
                        return Array.isArray(parsed) ? parsed.join(', ') : row.qtyList;
                      } catch {
                        return row.qtyList;
                      }
                    })()}
                  </td>
                  <td>{row.qty}</td>
                  <td>{row.tare}</td>
                  <td>{row.water}</td>
                  {rows.some(r => r.stick && r.stick !== 0) && <td>{row.stick}</td>}
                  <td>{row.netweight}</td>
                  <td>{row.empid}</td>
                  <td>
                    {/* <FaSms
                      className="action-icon sms-icon"
                      title="Send SMS"
                      onClick={() => handleSMSPreview(row)}
                    />
                    <FaWhatsapp
                      className="action-icon whatsapp-icon"
                      title="Send WhatsApp"
                      onClick={() => handleSMSPreview(row)}
                    /> */}
                    <div className='actionsicon'  >
                       <FaPaperPlane
                      className="action-icon sendd-icon"
                      title="Send WhatsApp"
                      onClick={() => handleSMSPreview(row)}
                    /> 
                    <FaTrash
    className="action-icon delete-icon"
    title="Delete Record"
    onClick={() => {
      setDeleteBillNo(row.billno);
      setShowDeleteDialog(true);
    }}
  /> </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
      <div className="tea-pagination">
        <button onClick={() => setPage(p => Math.max(p - 1, 0))} disabled={page === 0}>
          Prev
        </button>
        <span>Page {page + 1} of {totalPages}</span>
        <button onClick={() => setPage(p => Math.min(p + 1, totalPages - 1))} disabled={page >= totalPages - 1}>
          Next
        </button>
      </div>

      {showSMSPreview && previewSMS && (
        <div className="sms-preview-overlay">
          <div className="sms-preview-modal">
            <h3>Message Preview</h3>
            <p><strong>To:</strong> {previewSMS.ph}</p>
            <pre>{previewSMS.message}</pre>
            <div className="preview-buttons">
              <button onClick={sendSMSNow}>  <FaSms className='ic' />   Send SMS</button>
              <button onClick={sendToWhatsApp}> <FaWhatsapp className='ic' />  Send WhatsApp</button>
              <button onClick={() => setShowSMSPreview(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
      {showDeleteDialog && (
  <div className="delete-dialog">
    <div className="delete-dialog-content">
      <p>Do you want to delete this record?</p>
      <button
        onClick={() => handleDelete(deleteBillNo)}
        className="yes-button"
      >
        Yes
      </button>
      <button
        onClick={() => setShowDeleteDialog(false)}
        className="no-button"
      >
        No
      </button>
    </div>
  </div>
)}

    </div>
  );
};

export default Collecttea;

